import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { dbService } from '../lib/supabase';

/**
 * Records CDMO claim campaign link click, then redirects to claim signup (existing flow).
 */
const CampaignClickPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const cdmoId = searchParams.get('cdmo_id');
    const token = searchParams.get('token');
    const email = searchParams.get('email');

    if (!cdmoId || !token) {
      setError('This link is invalid or incomplete.');
      return;
    }

    let cancelled = false;

    const run = async () => {
      try {
        await dbService.recordCdmoClaimLinkClick(cdmoId);
        if (cancelled) return;

        const params = new URLSearchParams();
        params.set('token', token);
        if (email) params.set('email', email);
        params.set('id', cdmoId);
        navigate(`/startup-signup?${params.toString()}`, { replace: true });
      } catch (e) {
        console.error('CampaignClickPage:', e);
        if (!cancelled) setError('Unable to continue. Please try again later.');
      }
    };

    void run();
    return () => {
      cancelled = true;
    };
  }, [searchParams, navigate]);

  if (error) {
    return (
      <div className="min-h-[50vh] flex items-center justify-center px-4">
        <p className="text-charcoal text-center max-w-md">{error}</p>
      </div>
    );
  }

  return (
    <div className="min-h-[50vh] flex flex-col items-center justify-center px-4">
      <Loader2 className="w-10 h-10 text-electric-blue animate-spin mb-4" />
      <p className="text-slate-gray">Redirecting…</p>
    </div>
  );
};

export default CampaignClickPage;
